import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import InputAdornment from "@mui/material/InputAdornment";
import Iphone from "../../assets/colors.png";
import { Home, Settings } from "tabler-icons-react";
import { useAlert } from "react-alert";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { timezones } from "../../utils/Timezones";
import { useNavigate } from "react-router-dom";
import { InfoCircle, Eye, EyeOff } from "tabler-icons-react";
import Step1 from "../../assets/step1.png";
import Step2 from "../../assets/step2.png";
import Step3 from "../../assets/step3.png";
import Step10 from "../../assets/step10.png";
import Step11 from "../../assets/step11.png";
import {
	CircularProgress,
	Divider,
	Modal,
	Step,
	StepContent,
	StepLabel,
	Stepper,
	IconButton,
	ListSubheader,
	ListItemText,
} from "@mui/material";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import WelcomeImage from "../../assets/onboarding.png";
import OnboardingFinishedImage from "../../assets/onboarding-2.png";
import imageCompression from "browser-image-compression";

const usaCanada = [
	{
		name: "Canada",
		id: "Canada",
	},
	{
		name: "United States",
		id: "United States",
	},
];
const europe = [
	{ name: "Albania", id: "Albania" },
	{ name: "Austria", id: "Austria" },
	{ name: "Belarus", id: "Belarus" },
	{ name: "Belgium", id: "Belgium" },
	{ name: "Bosnia and Herzegovina", id: "Bosnia and Herzegovina" },
	{ name: "Bulgaria", id: "Bulgaria" },
	{ name: "Croatia", id: "Croatia" },
	{ name: "Cyprus", id: "Cyprus" },
	{ name: "Czech Republic", id: "Czech Republic" },
	{ name: "Denmark", id: "Denmark" },
	{ name: "Estonia", id: "Estonia" },
	{ name: "Finland", id: "Finland" },
	{ name: "France", id: "France" },
	{ name: "Germany", id: "Germany" },
	{ name: "Greece", id: "Greece" },
	{ name: "Hungary", id: "Hungary" },
	{ name: "Iceland", id: "Iceland" },
	{ name: "Ireland", id: "Ireland" },
	{ name: "Italy", id: "Italy" },
	{ name: "Kosovo", id: "Kosovo" },
	{ name: "Latvia", id: "Latvia" },
	{ name: "Lithuania", id: "Lithuania" },
	{ name: "Luxembourg", id: "Luxembourg" },
	{ name: "Malta", id: "Malta" },
	{ name: "Moldova", id: "Moldova" },
	{ name: "Montenegro", id: "Montenegro" },
	{ name: "Netherlands", id: "Netherlands" },
	{ name: "North Macedonia", id: "North Macedonia" },
	{ name: "Norway", id: "Norway" },
	{ name: "Poland", id: "Poland" },
	{ name: "Portugal", id: "Portugal" },
	{ name: "Romania", id: "Romania" },
	{ name: "Russia", id: "Russia" },
	{ name: "Serbia", id: "Serbia" },
	{ name: "Slovakia", id: "Slovakia" },
	{ name: "Slovenia", id: "Slovenia" },
	{ name: "Spain", id: "Spain" },
	{ name: "Sweden", id: "Sweden" },
	{ name: "Switzerland", id: "Switzerland" },
	{ name: "Türkiye", id: "Türkiye" },
	{ name: "Ukraine", id: "Ukraine" },
	{ name: "United Kingdom", id: "United Kingdom" },
];
const africaMiddleEastIndia = [
	{ name: "Afghanistan", id: "Afghanistan" },
	{ name: "Algeria", id: "Algeria" },
	{ name: "Angola", id: "Angola" },
	{ name: "Armenia", id: "Armenia" },
	{ name: "Azerbaijan", id: "Azerbaijan" },
	{ name: "Bahrain", id: "Bahrain" },
	{ name: "Benin", id: "Benin" },
	{ name: "Botswana", id: "Botswana" },
	{ name: "Burkina Faso", id: "Burkina Faso" },
	{ name: "Cameroon", id: "Cameroon" },
	{ name: "Cape Verde", id: "Cape Verde" },
	{ name: "Chad", id: "Chad" },
	{
		name: "Congo, Democratic Republic of the",
		id: "Congo, Democratic Republic of the",
	},
	{ name: "Congo, Republic of the", id: "Congo, Republic of the" },
	{ name: "Côte d’Ivoire", id: "Côte d’Ivoire" },
	{ name: "Egypt", id: "Egypt" },
	{ name: "Eswatini", id: "Eswatini" },
	{ name: "Gabon", id: "Gabon" },
	{ name: "Gambia", id: "Gambia" },
	{ name: "Georgia", id: "Georgia" },
	{ name: "Ghana", id: "Ghana" },
	{ name: "Guinea-Bissau", id: "Guinea-Bissau" },
	{ name: "India", id: "India" },
	{ name: "Iraq", id: "Iraq" },
	{ name: "Israel", id: "Israel" },
	{ name: "Jordan", id: "Jordan" },
	{ name: "Kenya", id: "Kenya" },
	{ name: "Kuwait", id: "Kuwait" },
	{ name: "Lebanon", id: "Lebanon" },
	{ name: "Liberia", id: "Liberia" },
	{ name: "Libya", id: "Libya" },
	{ name: "Madagascar", id: "Madagascar" },
	{ name: "Malawi", id: "Malawi" },
	{ name: "Mali", id: "Mali" },
	{ name: "Mauritania", id: "Mauritania" },
	{ name: "Mauritius", id: "Mauritius" },
	{ name: "Morocco", id: "Morocco" },
	{ name: "Mozambique", id: "Mozambique" },
	{ name: "Namibia", id: "Namibia" },
	{ name: "Niger", id: "Niger" },
	{ name: "Nigeria", id: "Nigeria" },
	{ name: "Oman", id: "Oman" },
	{ name: "Qatar", id: "Qatar" },
	{ name: "Rwanda", id: "Rwanda" },
	{ name: "São Tomé and Príncipe", id: "São Tomé and Príncipe" },
	{ name: "Saudi Arabia", id: "Saudi Arabia" },
	{ name: "Senegal", id: "Senegal" },
	{ name: "Seychelles", id: "Seychelles" },
	{ name: "Sierra Leone", id: "Sierra Leone" },
	{ name: "South Africa", id: "South Africa" },
	{ name: "Tanzania", id: "Tanzania" },
	{ name: "Tunisia", id: "Tunisia" },
	{ name: "Uganda", id: "Uganda" },
	{ name: "United Arab Emirates", id: "United Arab Emirates" },
	{ name: "Yemen", id: "Yemen" },
	{ name: "Zambia", id: "Zambia" },
	{ name: "Zimbabwe", id: "Zimbabwe" },
];
const latamCaribbean = [
	{ name: "Anguilla", id: "Anguilla" },
	{ name: "Antigua and Barbuda", id: "Antigua and Barbuda" },
	{ name: "Argentina", id: "Argentina" },
	{ name: "Bahamas", id: "Bahamas" },
	{ name: "Barbados", id: "Barbados" },
	{ name: "Belize", id: "Belize" },
	{ name: "Bermuda", id: "Bermuda" },
	{ name: "Bolivia", id: "Bolivia" },
	{ name: "Brazil", id: "Brazil" },
	{ name: "British Virgin Islands", id: "British Virgin Islands" },
	{ name: "Cayman Islands", id: "Cayman Islands" },
	{ name: "Chile", id: "Chile" },
	{ name: "Colombia", id: "Colombia" },
	{ name: "Costa Rica", id: "Costa Rica" },
	{ name: "Dominica", id: "Dominica" },
	{ name: "Dominican Republic", id: "Dominican Republic" },
	{ name: "Ecuador", id: "Ecuador" },
	{ name: "El Salvador", id: "El Salvador" },
	{ name: "Grenada", id: "Grenada" },
	{ name: "Guatemala", id: "Guatemala" },
	{ name: "Guyana", id: "Guyana" },
	{ name: "Honduras", id: "Honduras" },
	{ name: "Jamaica", id: "Jamaica" },
	{ name: "Mexico", id: "Mexico" },
	{ name: "Montserrat", id: "Montserrat" },
	{ name: "Nicaragua", id: "Nicaragua" },
	{ name: "Panama", id: "Panama" },
	{ name: "Paraguay", id: "Paraguay" },
	{ name: "Peru", id: "Peru" },
	{ name: "St. Kitts and Nevis", id: "St. Kitts and Nevis" },
	{ name: "St. Lucia", id: "St. Lucia" },
	{
		name: "St. Vincent and the Grenadines",
		id: "St. Vincent and the Grenadines",
	},
	{ name: "Suriname", id: "Suriname" },
	{ name: "Trinidad and Tobago", id: "Trinidad and Tobago" },
	{ name: "Turks and Caicos Islands", id: "Turks and Caicos Islands" },
	{ name: "Uruguay", id: "Uruguay" },
	{ name: "Venezuela", id: "Venezuela" },
];
const asia = [
	{ name: "Australia", id: "Australia" },
	{ name: "Bhutan", id: "Bhutan" },
	{ name: "Brunei", id: "Brunei" },
	{ name: "Cambodia", id: "Cambodia" },
	{ name: "China mainland", id: "China mainland" },
	{ name: "Fiji", id: "Fiji" },
	{ name: "Hong Kong", id: "Hong Kong" },
	{ name: "Indonesia", id: "Indonesia" },
	{ name: "Japan", id: "Japan" },
	{ name: "Kazakhstan", id: "Kazakhstan" },
	{ name: "Korea, Republic of", id: "Korea, Republic of" },
	{ name: "Kyrgyzstan", id: "Kyrgyzstan" },
	{ name: "Laos", id: "Laos" },
	{ name: "Macau", id: "Macau" },
	{ name: "Malaysia", id: "Malaysia" },
	{ name: "Maldives", id: "Maldives" },
	{ name: "Micronesia", id: "Micronesia" },
	{ name: "Mongolia", id: "Mongolia" },
	{ name: "Myanmar", id: "Myanmar" },
	{ name: "Nauru", id: "Nauru" },
	{ name: "Nepal", id: "Nepal" },
	{ name: "New Zealand", id: "New Zealand" },
	{ name: "Pakistan", id: "Pakistan" },
	{ name: "Palau", id: "Palau" },
	{ name: "Papua New Guinea", id: "Papua New Guinea" },
	{ name: "Philippines", id: "Philippines" },
	{ name: "Singapore", id: "Singapore" },
	{ name: "Solomon Islands", id: "Solomon Islands" },
	{ name: "Sri Lanka", id: "Sri Lanka" },
	{ name: "Taiwan", id: "Taiwan" },
	{ name: "Tajikistan", id: "Tajikistan" },
	{ name: "Thailand", id: "Thailand" },
	{ name: "Tonga", id: "Tonga" },
	{ name: "Turkmenistan", id: "Turkmenistan" },
	{ name: "Uzbekistan", id: "Uzbekistan" },
	{ name: "Vanuatu", id: "Vanuatu" },
	{ name: "Vietnam", id: "Vietnam" },
];

const useStyles = makeStyles({
	alert: {
		cursor: "pointer",
		"& *": {
			cursor: "pointer",
		},
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	},
	pickerContainer: {
		"& #font-picker": {
			width: "100%!important",
			background: "none!important",
			backgroundColor: "none!important",
			boxShadow: "none!important",
			border: "1px solid #D0D0D0",
			borderRadius: 4,
			padding: 4,
		},

		"& #font-picker button": {
			background: "none!important",
		},
		"& #font-picker ul": {
			background: "fafafa!important",
			boxShadow: "none!important",
		},
	},
	logo: {
		height: "100%",
		objectFit: "contain",
		maxWidth: 100,
		margin: "12px 0px",
	},
	formControl: {
		"& hover": {
			backgroundColor: "#434343",
		},
	},
	indeterminateColor: {
		color: "#43BD98!important",
	},
});

export default function Metadata({ drawerWidth }) {
	const [loading, setLoading] = useState(false);
	const [generalData, setGeneralData] = useState(null);
	const { user } = useContext(UserContext);
	const classes = useStyles();
	const alert = useAlert();
	const { t } = useTranslation();
	const [imagesLoading, setImagesLoading] = useState({});

	const categories = [
		{ name: t("metadata.primary"), id: "Primary" },
		{ name: t("metadata.books"), id: "Books" },
		{ name: t("metadata.business"), id: "Business" },
		{ name: t("metadata.developerTools"), id: "Developer Tools" },
		{ name: t("metadata.education"), id: "Education" },
		{ name: t("metadata.entertainment"), id: "Entertainment" },
		{ name: t("metadata.finance"), id: "Finance" },
		{ name: t("metadata.food"), id: "Food & Drink" },
		{ name: t("metadata.games"), id: "Games" },
		{ name: t("metadata.graphics"), id: "Graphics & Design" },
		{ name: t("metadata.health"), id: "Health & Fitness" },
		{ name: t("metadata.lifestyle"), id: "Lifestyle" },
		{ name: t("metadata.magazines"), id: "Magazines & Newspapers" },
		{ name: t("metadata.medical"), id: "Medical" },
		{ name: t("metadata.music"), id: "Music" },
		{ name: t("metadata.navigation"), id: "Navigation" },
		{ name: t("metadata.news"), id: "News" },
		{ name: t("metadata.photo"), id: "Photo & Video" },
		{ name: t("metadata.productivity"), id: "Productivity" },
		{ name: t("metadata.reference"), id: "Reference" },
		{ name: t("metadata.shopping"), id: "Shopping" },
		{ name: t("metadata.social"), id: "Social Networking" },
		{ name: t("metadata.sports"), id: "Sports" },
		{ name: t("metadata.stickers"), id: "Stickers" },
		{ name: t("metadata.travel"), id: "Travel" },
		{ name: t("metadata.utilities"), id: "Utilities" },
		{ name: t("metadata.weather"), id: "Weather" },
	];

	const saveGeneralData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "metadata",
				{
					...generalData,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [generalData]);

	useEffect(() => {
		const getMetadata = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "metadata", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setGeneralData(res.data.metadata);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getMetadata();
	}, []);

	const openFile = async (file, key, options, generalData, imagesLoading) => {
		setImagesLoading({ ...imagesLoading, [key]: true });

		let compressedFile = await imageCompression(file.target.files[0], {
			maxSizeMB: 3,
		});

		const reader = new FileReader();
		reader.onload = function () {
			const saveFile = async (dataURL) => {
				setGeneralData({
					...generalData,
					[key]: dataURL,
				});
			};
			const dataURL = reader.result;
			if (options) {
				const image = new Image();
				image.src = dataURL;
				image.onload = function () {
					const height = this.height;
					const width = this.width;
					if (options.height !== height || options.width > width) {
						alert.show(options.message, { type: "error" });
					} else {
						saveFile(dataURL);
					}
				};
			} else {
				saveFile(dataURL);
			}
			setImagesLoading({ ...imagesLoading, [key]: false });
		};
		console.log(compressedFile);
		reader.readAsDataURL(compressedFile);
	};

	const renderCountriesSelect = () => {
		return [
			<MenuItem key={"all"} value={"all"}>
				<Checkbox
					classes={{ indeterminate: classes.indeterminateColor }}
					checked={
						generalData?.countryAvailability?.length ===
						usaCanada.length +
							europe.length +
							africaMiddleEastIndia.length +
							latamCaribbean.length +
							asia.length
					}
					indeterminate={
						generalData?.countryAvailability?.length > 0 &&
						generalData?.countryAvailability?.length <
							usaCanada.length +
								europe.length +
								africaMiddleEastIndia.length +
								latamCaribbean.length +
								asia.length
					}
				/>
				<ListItemText
					primary={
						generalData?.countryAvailability?.length ===
						usaCanada.length +
							europe.length +
							africaMiddleEastIndia.length +
							latamCaribbean.length +
							asia.length
							? t("metadata.unselectAll")
							: t("metadata.selectAll")
					}
				/>
			</MenuItem>,

			<ListSubheader>{t("metadata.usaCanada")}</ListSubheader>,
			...usaCanada.map(({ name, id }) => (
				<MenuItem key={name} value={id}>
					<Checkbox
						checked={generalData?.countryAvailability?.indexOf(name) > -1}
					/>
					<ListItemText primary={name} />
				</MenuItem>
			)),
			<ListSubheader>{t("metadata.europe")}</ListSubheader>,
			...europe.map(({ name, id }) => (
				<MenuItem key={name} value={id}>
					<Checkbox
						checked={generalData?.countryAvailability?.indexOf(name) > -1}
					/>
					<ListItemText primary={name} />
				</MenuItem>
			)),
			<ListSubheader>{t("metadata.africaMiddleEastIndia")}</ListSubheader>,
			...africaMiddleEastIndia.map(({ name, id }) => (
				<MenuItem key={name} value={id}>
					<Checkbox
						checked={generalData?.countryAvailability?.indexOf(name) > -1}
					/>
					<ListItemText primary={name} />
				</MenuItem>
			)),
			<ListSubheader>{t("metadata.latamCaribbean")}</ListSubheader>,
			...latamCaribbean.map(({ name, id }) => (
				<MenuItem key={name} value={id}>
					<Checkbox
						checked={generalData?.countryAvailability?.indexOf(name) > -1}
					/>
					<ListItemText primary={name} />
				</MenuItem>
			)),
			<ListSubheader>{t("metadata.asia")}</ListSubheader>,
			...asia.map(({ name, id }) => (
				<MenuItem key={name} value={id}>
					<Checkbox
						checked={generalData?.countryAvailability?.indexOf(name) > -1}
					/>
					<ListItemText primary={name} />
				</MenuItem>
			)),
		];
	};

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
				}}
			>
				<Toolbar />
				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									minHeight: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("metadata.mainTitle")}
							</Typography>
							{generalData && (
								<>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="metadata-category"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.category")}
										</InputLabel>
										<TextField
											select
											id="metadata-category"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.category}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													category: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										>
											{categories.map((option) => (
												<MenuItem value={option.id}>{option.name}</MenuItem>
											))}
										</TextField>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="metadata-category"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.countryAvailability")}
										</InputLabel>
										<TextField
											select
											id="metadata-category"
											fullWidth
											SelectProps={{
												multiple: true,
												value: generalData.countryAvailability ?? [],
												onChange: (event) => {
													const value = event.target.value;
													if (value[value.length - 1] === "all") {
														setGeneralData({
															...generalData,
															countryAvailability:
																generalData?.countryAvailability?.length ===
																usaCanada.length +
																	europe.length +
																	africaMiddleEastIndia.length +
																	latamCaribbean.length +
																	asia.length
																	? []
																	: [
																			...usaCanada.map((c) => c.id),
																			...europe.map((c) => c.id),
																			...africaMiddleEastIndia.map((c) => c.id),
																			...latamCaribbean.map((c) => c.id),
																			...asia.map((c) => c.id),
																	  ],
														});
														return;
													}

													setGeneralData({
														...generalData,
														countryAvailability: value,
													});
												},
												renderValue: (selected) => selected.join(", "),
											}}
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.countryAvailability}
											onChange={(e) => {
												console.log(e.target.value);
												setGeneralData({
													...generalData,
													countryAvailability: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										>
											{renderCountriesSelect()}
										</TextField>
									</FormControl>

									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.privacyURL")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.privacyURL}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													privacyURL: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.termsURL")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.termsURL}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													termsURL: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.supportURL")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.supportURL}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													supportURL: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.marketingURL")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.marketingURL}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													marketingURL: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-delete-account-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.deleteAccountURL")}
											<small style={{ marginLeft: 5 }}>
												<a
													href="https://developer.apple.com/support/offering-account-deletion-in-your-app"
													target="_blank"
													rel="noreferrer"
												>
													(iOS)
												</a>
											</small>
											<small> & </small>
											<small>
												<a
													href="https://support.google.com/googleplay/android-developer/answer/13327111"
													target="_blank"
													rel="noreferrer"
												>
													(Android)
												</a>
											</small>
										</InputLabel>
										<TextField
											id="app-delete-account-input"
											fullWidth
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.deleteAccountURL}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													deleteAccountURL: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 2 }}
										className={classes.formControl}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("metadata.keywords")}
										</InputLabel>
										<TextField
											id="app-name-input"
											fullWidth
											placeholder={t("metadata.keywordsPlaceholder")}
											InputProps={{
												readOnly: ["building"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												),
											}}
											variant="outlined"
											value={generalData.keywords}
											onChange={(e) => {
												setGeneralData({
													...generalData,
													keywords: e.target.value,
												});
											}}
											disabled={["publishing", "published"].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									</FormControl>

									<Divider sx={{ marginBottom: 2, marginTop: 2 }} />
									<Typography variant="h6" sx={{ marginBottom: 2 }}>
										{t("metadata.appPreviews")}{" "}
										<small>(1290 x 2796 pixels)</small>
									</Typography>
									<Box
										sx={{
											display: "flex",
											gap: 2,
											justifyContent: "space-between",
											flexWrap: "wrap",
										}}
									>
										<FormControl
											fullWidth
											variant="standard"
											sx={{
												marginTop: 2,
												marginBottom: 2,
												width: {
													xs: "100%",
													sm: "100%",
													md: "100%",
													lg: "calc(50% - 12px)",
													xl: "calc(25% - 12px)",
												},
											}}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{"#1"}
											</InputLabel>

											<TextField
												id="app-description-input"
												fullWidth
												variant="outlined"
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="start">
															<Box>
																<Button
																	size="small"
																	variant="contained"
																	component="label"
																	color="primary"
																	disabled={["publishing", "published"].find(
																		(status) =>
																			status ===
																			(user.app.appStatuses.length === 0
																				? ""
																				: user.app.appStatuses.length > 0 &&
																				  user.app.appStatuses[0].status)
																	)}
																	sx={{
																		height: "24px",
																		fontSize: "10px",
																	}}
																>
																	{imagesLoading.appPreview1 ? (
																		<CircularProgress
																			sx={{ color: "white!important" }}
																			size={12}
																		/>
																	) : (
																		t("general.upload")
																	)}
																	<input
																		type="file"
																		accept="image/png, image/jpeg"
																		hidden
																		onChange={(e) => {
																			openFile(
																				e,
																				"appPreview1",
																				{
																					width: 1290,
																					height: 2796,
																					message: t("metadata.invalidSize"),
																				},
																				generalData,
																				imagesLoading
																			);
																		}}
																	/>
																</Button>
															</Box>
														</InputAdornment>
													),
													endAdornment: generalData.appPreview1 && (
														<Box sx={{ position: "relative" }}>
															<img
																className={classes.logo}
																src={generalData.appPreview1}
																alt="logo"
															/>
															<IconButton
																color="inherit"
																aria-label="delete image"
																edge="start"
																onClick={() => {
																	setGeneralData({
																		...generalData,
																		appPreview1: null,
																	});
																}}
																disabled={["publishing", "published"].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)}
																sx={{
																	position: "absolute",
																	background: "#43BD98",
																	top: 0,
																	right: "-15px",
																	width: "24px",
																	height: "24px",
																	"&:hover": {
																		background: "#43BD98!important",
																	},
																}}
															>
																<Close
																	sx={{ color: "#fff" }}
																	style={{ width: 12, height: 12 }}
																/>
															</IconButton>
														</Box>
													),
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											></TextField>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{
												marginTop: 2,
												marginBottom: 2,
												width: {
													xs: "100%",
													sm: "100%",
													md: "100%",
													lg: "calc(50% - 12px)",
													xl: "calc(25% - 12px)",
												},
											}}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{"#2"}
											</InputLabel>

											<TextField
												id="app-description-input"
												fullWidth
												variant="outlined"
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="start">
															<Box>
																<Button
																	size="small"
																	variant="contained"
																	component="label"
																	color="primary"
																	disabled={["publishing", "published"].find(
																		(status) =>
																			status ===
																			(user.app.appStatuses.length === 0
																				? ""
																				: user.app.appStatuses.length > 0 &&
																				  user.app.appStatuses[0].status)
																	)}
																	sx={{
																		height: "24px",
																		fontSize: "10px",
																	}}
																>
																	{imagesLoading.appPreview2 ? (
																		<CircularProgress
																			sx={{ color: "white!important" }}
																			size={12}
																		/>
																	) : (
																		t("general.upload")
																	)}
																	<input
																		type="file"
																		accept="image/png, image/jpeg"
																		hidden
																		onChange={(e) => {
																			openFile(
																				e,
																				"appPreview2",
																				{
																					width: 1290,
																					height: 2796,
																					message: t("metadata.invalidSize"),
																				},
																				generalData,
																				imagesLoading
																			);
																		}}
																	/>
																</Button>
															</Box>
														</InputAdornment>
													),
													endAdornment: generalData.appPreview2 && (
														<Box sx={{ position: "relative" }}>
															<img
																className={classes.logo}
																src={generalData.appPreview2}
																alt="logo"
															/>
															<IconButton
																color="inherit"
																aria-label="delete image"
																edge="start"
																onClick={() => {
																	setGeneralData({
																		...generalData,
																		appPreview2: null,
																	});
																}}
																disabled={["publishing", "published"].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)}
																sx={{
																	position: "absolute",
																	background: "#43BD98",
																	top: 0,
																	right: "-15px",
																	width: "24px",
																	height: "24px",
																	"&:hover": {
																		background: "#43BD98!important",
																	},
																}}
															>
																<Close
																	sx={{ color: "#fff" }}
																	style={{ width: 12, height: 12 }}
																/>
															</IconButton>
														</Box>
													),
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											></TextField>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{
												marginTop: 2,
												marginBottom: 2,
												width: {
													xs: "100%",
													sm: "100%",
													md: "100%",
													lg: "calc(50% - 12px)",
													xl: "calc(25% - 12px)",
												},
											}}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{"#3"}
											</InputLabel>

											<TextField
												id="app-description-input"
												fullWidth
												variant="outlined"
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="start">
															<Box>
																<Button
																	size="small"
																	variant="contained"
																	component="label"
																	color="primary"
																	disabled={["publishing", "published"].find(
																		(status) =>
																			status ===
																			(user.app.appStatuses.length === 0
																				? ""
																				: user.app.appStatuses.length > 0 &&
																				  user.app.appStatuses[0].status)
																	)}
																	sx={{
																		height: "24px",
																		fontSize: "10px",
																	}}
																>
																	{imagesLoading.appPreview3 ? (
																		<CircularProgress
																			sx={{ color: "white!important" }}
																			size={12}
																		/>
																	) : (
																		t("general.upload")
																	)}
																	<input
																		type="file"
																		accept="image/png, image/jpeg"
																		hidden
																		onChange={(e) => {
																			openFile(
																				e,
																				"appPreview3",
																				{
																					width: 1290,
																					height: 2796,
																					message: t("metadata.invalidSize"),
																				},
																				generalData,
																				imagesLoading
																			);
																		}}
																	/>
																</Button>
															</Box>
														</InputAdornment>
													),
													endAdornment: generalData.appPreview3 && (
														<Box sx={{ position: "relative" }}>
															<img
																className={classes.logo}
																src={generalData.appPreview3}
																alt="logo"
															/>
															<IconButton
																color="inherit"
																aria-label="delete image"
																edge="start"
																onClick={() => {
																	setGeneralData({
																		...generalData,
																		appPreview3: null,
																	});
																}}
																disabled={["publishing", "published"].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)}
																sx={{
																	position: "absolute",
																	background: "#43BD98",
																	top: 0,
																	right: "-15px",
																	width: "24px",
																	height: "24px",
																	"&:hover": {
																		background: "#43BD98!important",
																	},
																}}
															>
																<Close
																	sx={{ color: "#fff" }}
																	style={{ width: 12, height: 12 }}
																/>
															</IconButton>
														</Box>
													),
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											></TextField>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{
												marginTop: 2,
												marginBottom: 2,
												width: {
													xs: "100%",
													sm: "100%",
													md: "100%",
													lg: "calc(50% - 12px)",
													xl: "calc(25% - 12px)",
												},
											}}
										>
											<InputLabel
												shrink
												htmlFor="app-description-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{"#4"}
											</InputLabel>

											<TextField
												id="app-description-input"
												fullWidth
												variant="outlined"
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="start">
															<Box>
																<Button
																	size="small"
																	variant="contained"
																	component="label"
																	color="primary"
																	disabled={["publishing", "published"].find(
																		(status) =>
																			status ===
																			(user.app.appStatuses.length === 0
																				? ""
																				: user.app.appStatuses.length > 0 &&
																				  user.app.appStatuses[0].status)
																	)}
																	sx={{
																		height: "24px",
																		fontSize: "10px",
																	}}
																>
																	{imagesLoading.appPreview4 ? (
																		<CircularProgress
																			sx={{ color: "white!important" }}
																			size={12}
																		/>
																	) : (
																		t("general.upload")
																	)}
																	<input
																		type="file"
																		accept="image/png, image/jpeg"
																		hidden
																		onChange={(e) => {
																			openFile(
																				e,
																				"appPreview4",
																				{
																					width: 1290,
																					height: 2796,
																					message: t("metadata.invalidSize"),
																				},
																				generalData,
																				imagesLoading
																			);
																		}}
																	/>
																</Button>
															</Box>
														</InputAdornment>
													),
													endAdornment: generalData.appPreview4 && (
														<Box sx={{ position: "relative" }}>
															<img
																className={classes.logo}
																src={generalData.appPreview4}
																alt="logo"
															/>
															<IconButton
																color="inherit"
																aria-label="delete image"
																edge="start"
																onClick={() => {
																	setGeneralData({
																		...generalData,
																		appPreview4: null,
																	});
																}}
																disabled={["publishing", "published"].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)}
																sx={{
																	position: "absolute",
																	background: "#43BD98",
																	top: 0,
																	right: "-15px",
																	width: "24px",
																	height: "24px",
																	"&:hover": {
																		background: "#43BD98!important",
																	},
																}}
															>
																<Close
																	sx={{ color: "#fff" }}
																	style={{ width: 12, height: 12 }}
																/>
															</IconButton>
														</Box>
													),
												}}
												disabled={["publishing", "published"].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											></TextField>
										</FormControl>
									</Box>
								</>
							)}
						</CardContent>
						{!["publishing", "published"].find(
							(status) =>
								status ===
								(user.app.appStatuses.length === 0
									? ""
									: user.app.appStatuses.length > 0 &&
									  user.app.appStatuses[0].status)
						) && (
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={saveGeneralData}
									disabled={loading}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						)}
					</>
				</Card>
			</Box>
		</>
	);
}
